import React, { useState, useEffect } from 'react';

const TypingAnimation = ({ texts }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const fullText = texts[textIndex];
      
      if (!isDeleting) {
        if (currentIndex < fullText.length) {
          setCurrentText(fullText.substring(0, currentIndex + 1));
          setCurrentIndex(currentIndex + 1);
        } else {
          setTimeout(() => {
            setIsDeleting(true);
          }, 2000);
        }
      } else {
        if (currentIndex > 0) {
          setCurrentText(fullText.substring(0, currentIndex - 1));
          setCurrentIndex(currentIndex - 1);
        } else {
          setIsDeleting(false);
          setTextIndex((textIndex + 1) % texts.length);
        }
      }
    }, isDeleting ? 50 : 100);

    return () => clearTimeout(timeout);
  }, [currentIndex, isDeleting, textIndex, texts]);

  return <span className="typing">{currentText}</span>;
};

export default TypingAnimation;